
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import Input from '../../components/formComponents/input';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';
import VideoPlayer from '../../components/common/video';

// import Edit from './edit';

/*Assets*/
import Deals from '../../assets/images/deals.png';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';

class ScheduledAds extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 1,
      pageNum: 1,
      status: null,
      data:[],
      filter: {value: undefined},
      apiLoading: false
    }
  }

  componentDidMount() {
    this.getData();
    let type = 1;
    if(localStorage.getItem("vendor_data")){
      type = JSON.parse(localStorage.getItem("vendor_data")).seller_type
    } 
    this.setState({seller_type: type});
  }
  getData(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'ads/scheduled';
    var data = JSON.stringify({
        "page_num": 1,
        "status": this.state.filter.value
    })
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({data: response.data,apiLoading: false});
      }
    }.bind(this))
  }

  tabItemClick(tempItem){
    this.setState({tabIndex: tempItem});
  }
  selectChange = async (filter) => {
    await this.setState({filter: filter});
    await this.getData()
  }
  cancelSchedule(data){
    var url = devconfig.vendor+'ads/cancel';
    var data = JSON.stringify({
        "id": data.id
    })
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        window.location.reload()
      }
    }.bind(this))
  }
  cancelConfirm(data){
    var confirm = window.confirm("Cancel this schedule? \n\nClick OK to confirm.")
    if(confirm){
      this.cancelSchedule(data)
    }
  }

  render() {

     const filterBy = [
      { value: undefined, label: 'All' },
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]

    const linkVerify = (item)=>{
      var tempLink = item;
      if (item && !item.match(/^http([s]?):\/\/.*/)){
        tempLink = 'http://' + item;
        return tempLink
      }
      else{
        return item
      }
    }

    return (
      <div>
        <div className="e-main-content e-vendor-table">
          <h2 className="e-page-head">Scheduled Ads</h2>

              <div>
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="e-filter">Filter by</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-2">
                    <SelectBox defaultValue={this.state.filterDefault} options={filterBy} selectchange={this.selectChange}/>
                  </div>
                </div>
                {
                  this.state.apiLoading ?
                    <APILoader/>
                  :
                    <div className="row">
                      {
                        this.state.data.length?
                          this.state.data.map((item,index) => {

                            var tempClass = "";
                            if(item.status == "Ongoing"){
                              tempClass = "pl-lg-3 pl-md-0 pl-sm-0 e-completed text-success"
                            }
                            else if(item.status == "Upcoming"){
                              tempClass = "pl-lg-3 pl-md-0 pl-sm-0 e-completed text-primary"
                            }
                            else{
                              tempClass = "pl-lg-3 pl-md-0 pl-sm-0 e-completed text-danger"
                            }
                            return(
                              <div className="col-lg-12">
                                <div className="accordion pt-3" id="accordionExample">
                                  <div className="card e-vendor-category-list e-schedule-ads-accordion">
                                    <div className="card-header" id="headingOne">
                                      <div className="row no-gutters  e-schedule-ads">
                                        <div className="col-lg-12">
                                          <button className={this.state.activeAccordion === index ? "btn btn-link" : "btn btn-link collapsed" } type="button" data-toggle="collapse" onClick={(tempVal) => this.setState({activeAccordion: index})} data-target={"#collapseOne"+index} aria-expanded={this.state.activeAccordion === index ? "true" : "false" } aria-controls="collapseOne">
                                            <div className="row no-gutters pt-1">
                                              <div className="col-lg-3 col-md-3 col-sm-5 col-12 pl-0">
                                                <h6 className="text-left">Ad type</h6>
                                                <p className="text-left">{item.ads_location}</p>
                                                {
                                                  this.state.seller_type && this.state.seller_type === 1?
                                                  <>
                                                  {
                                                  item.category?<> 
                                                  <p className="text-left pt-2 font-weight-bold mb-2">Category </p>
                                                  <p>{item.category}</p>
                                                  </>: null
                                                }
                                                {
                                                  item.sub_category? <>
                                                  <p className="text-left pt-2 font-weight-bold mb-2">Subcategory </p>
                                                  <p>{item.sub_category}</p>
                                                  </>: null
                                                }</>
                                                :
                                                <>
                                                {
                                                  item.department?<> 
                                                  <p className="text-left pt-2 font-weight-bold mb-2">Category </p>
                                                  <p>{item.department}</p>
                                                  </>: null
                                                }
                                                {
                                                  item.category? <>
                                                  <p className="text-left pt-2 font-weight-bold mb-2">Subcategory </p>
                                                  <p>{item.category}</p>
                                                  </>: null
                                                }
                                                </>
                                                }
                                              </div>

                                              <div className="col-lg-6 col-md-6 col-sm-7 col-12">
                                                <h6 className="text-left pl-lg-4 pl-md-0 pl-sm-0">Schedule</h6>
                                                <p className="pl-lg-3 pl-md-0 pl-sm-0  ml-lg-2 ml-md-0 ml-sm-0">
                                                  {item.booking_date} :  

                                                  {

                                                    item.slot_data.length <= 23 ?
                                                      <React.Fragment>
                                                        {
                                                          item.slot_data.map((slot, index2)=>{
                                                            return(
                                                              <span className="ml-1 e-adList-slot">{slot.slot}</span>
                                                            ) 
                                                          })
                                                        }
                                                      
                                                      </React.Fragment>
                                                    :
                                                      <React.Fragment>
                                                        <span className="ml-1 e-adList-slot">All Slots Booked</span>
                                                      </React.Fragment>
                                                    }
                                                </p>
                                              </div>
                                              <div className="col-lg-2 col-md-2 col-sm-12 col-12">
                                                <h6 className="text-left pl-lg-3 pl-md-0 pl-sm-0   e-status">Status:</h6>
                                                <p className={tempClass}>{item.status}</p>
                                              </div>
                                            </div>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div id={"collapseOne"+index} className={this.state.activeAccordion === index ? "collapse show" : "collapse"} aria-labelledby="headingOne" data-parent="#accordionExample">
                                      <div className="card-body e-schedule-ads-card">

                                        <div className="e-border-accordion e-schedule-ads-border">
                                          <h6 className="e-ad-type pt-3 pb-3 pl-2">Content</h6>
                                          <div className="row">
                                          {
                                            item.content.map((subItem,index)=> {
                                              return(
                                                <div className="col-lg-4 mb-3">
                                                  <div className="e-ad-dotted-border e-deals-border e-schedule-ad-preview">
                                                    {
                                                      subItem.image.indexOf(".mp4") > -1 ?
                                                        <VideoPlayer url={subItem.image} />
                                                      :
                                                        <img src={subItem.image} className="e-deals pb-4" alt="Offer Logo"/>
                                                    }
                                                    
                                                    <span className="e-ad-website-link"><a href={linkVerify(subItem.website_link) } target="_blank">{subItem.website_link}</a></span>
                                                  </div>
                                                </div>
                                                );
                                              })
                                          }

                                          </div>
                                          <div className="row pt-4 ml-2">
                                            {
                                              item.status!= "Cancelled" && item.status!= "Ongoing" ?
                                                <button className="e-s-btn e-new-ofer" type="submit" value="Submit" onClick={this.cancelConfirm.bind(this, item)}>Cancel Ad</button>
                                              :
                                                null
                                            }
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        :
                          <NoDataFound head="No data found"/>
                      }
                      </div>
                }
                


              </div>

        </div>


    </div>

    );
  }
}

export default ScheduledAds;
